import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';
import ResalesRequestService from '../../services/resales-request';
import BootstrapTable from 'react-bootstrap-table-next';
import Pagination from 'react-js-pagination';
import { Trans } from 'react-i18next';
import { parseDateBR } from 'helpers/date.js';
import Loading from 'components/Loading';
import { AdminProfiles, MasterAgentProfiles, ProfileType } from 'helpers/Enum'
import { useCompany, useProfile } from 'models';
import { DebounceInput } from 'react-debounce-input';

const CompaniesList = () => {
	const profile = useProfile()
	const defaultFilters = {
		search: '',
		per_page: 10,
		page: 1,
		company_type_id: 2,
		__ranking_type: 1,
		sort: 'id',
		sort_dir: 'desc',
		masteragent: MasterAgentProfiles.includes(profile.id) ? 1 : ""
	};

	
	const { setCompany } = useCompany()

	const isAdmin = AdminProfiles.includes(profile.id)
	const isMasterAgent = MasterAgentProfiles.includes(profile.id) ? 1 : 0
	const isElite = !MasterAgentProfiles.includes(profile.id) && !AdminProfiles.includes(profile.id)

	const [filters, setFilters] = useState(defaultFilters);
	const [companies, setCompanies] = useState({ data: [] });
	const [pagination, setPagination] = useState({});

	const [pageReturn, setPageReturn] = useState('/');
	const [isLoading, setIsLoading] = useState(false);
	const Data = [];

	useEffect(() => {
		setIsLoading(true);
		if (localStorage.getItem('returnPage') != null) {
			setPageReturn(localStorage.getItem('returnPage'));
			localStorage.removeItem('returnPage');
		}

		let aux_filters = { ...filters }

		if ([ProfileType.Attendance, ProfileType.Resale].includes(profile.type) && ![47, 49, 9].includes(profile.id)) { // add o 9, da uma olhada depois francis
			aux_filters = {
				...aux_filters,
				masteragent: isMasterAgent ? 1 : 0
			}
		}

		let companies = ResalesRequestService.getAllDetails({
			params: { ...aux_filters }
		});
		companies
			.then(data => {
				setCompanies(data.data);
				setPagination(data.data.pagination);
			}).finally(() => setIsLoading(false));
	}, [filters]);

	const handleFilterChange = (new_filters, reset = false) => {
		let f = { ...filters, ...new_filters };

		if (reset) f = { ...defaultFilters, ...new_filters };

		setFilters(f);
	};

	const handlePageChange = page => handleFilterChange({ page });

	const renderData = () => {
		var ids = [];
		let model = { id: 0, count: 0 }

		const _category = (category) => {
			if (category) {
				if (category == 1) return "Ouro"
				else return "Prata"
			} else return "--"
		}

		function _program(program){
			if(program == 4) return "Elite Pass";
			if(program == 5) return "ScanSource Select";

			return "Outros"
		}

		Object.values(companies.data)
			.map((company, k) => {
				var m = null;
				ids = ids.map(a => {
					if (a.id == company.id) {
						a.count += 1;
						m = a;
					}
					return a
				})
				if (m == null) {
					m = { ...model };
					m.id = company.id;
					m.count = 1;
					ids.push(m);
				}
				var id = m.id + '-' + m.count;
				var x = company.document.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/);
				var cnpj = !x[2] ? x[1] : x[1] + '.' + x[2] + '.' + x[3] + '/' + x[4] + (x[5] ? '-' + x[5] : '');

				const c = {
					id: id,
					btn: btn(company.id, company.company_name, company),
					name: company.company_name,
					document: cnpj,
					program: _program(company.is_premium),
					masteragent: company.is_masteragent == 1 ? 'Sim' : 'Não',
					ma_category: _category(company.ma_category),
					total_access: company.total_access,
					last_access: company.last_access_date != "--" ? parseDateBR(company.last_access_date) : "--",
				}

				Data.push(c);
			});
	}

	const getProgram = (is_premium) => {
		const programs = [
			"Outros",
			"Elite",
			"Elite Gerencial",
			"Scancash",
			"ScanSource Select"
		];

		return programs[is_premium]
	}

	const columns = [
		{
			dataField: 'name',
			text: 'Nome',
			headerStyle: {
				textAlign: 'center'
			},
			style: {
				textAlign: 'center'
			}
		},
		{
			dataField: 'document',
			text: 'CNPJ',
			headerStyle: {
				textAlign: 'center'
			},
			style: {
				textAlign: 'center'
			}
		},
		{
			dataField: 'program',
			text: 'Programa',
			headerStyle: {
				textAlign: 'center'
			},
			style: {
				textAlign: 'center'
			}
		},
		{
			dataField: 'masteragent',
			text: 'Master Agent',
			headerStyle: {
				textAlign: 'center'
			},
			style: {
				textAlign: 'center'
			}
		},
		{
			dataField: 'ma_category',
			text: 'Categoria',
			headerStyle: {
				textAlign: 'center'
			},
			style: {
				textAlign: 'center'
			}
		},
		{
			dataField: 'total_access',
			text: 'Qtd de acessos',
			headerStyle: {
				textAlign: 'center'
			},
			style: {
				textAlign: 'center'
			}
		},
		{
			dataField: 'last_access',
			text: 'Último acesso',
			headerStyle: {
				textAlign: 'center'
			},
			style: {
				textAlign: 'center'
			}
		},
		{
			dataField: 'btn',
			text: '',
			headerStyle: {
				width: '4%'
			},
			style: {
				textAlign: 'center'
			}
		},
	];

	function btn(id, name, company) {
		var btn_id = "btn-" + id;
		return (
			<Button
				variant="primary"
				className="font-12"
				type="button"
				id={btn_id}
				onClick={() => {
					ResalesRequestService.getResale(company.id, {
						params: {
							embed: "adhesion.fiscalYear,invoicing"
						}
					}).then(async ({ data }) => {
						const { data: selectedCompany } = data
						updateFiscalYear(selectedCompany)


						// await new Promise((resolve) => {
						// 	if (selectedCompany.adhesion.length > 0) {
						// 		const { fiscal_year } = data.data.adhesion.filter(item => item.fiscal_year.block !== 1)[0]
						// 		localStorage.setItem("Elite:fiscalYear", JSON.stringify(fiscal_year))
						// 	} else {
						// 		const { current_fiscal_year } = selectedCompany
						// 		localStorage.setItem("Elite:fiscalYear", JSON.stringify(current_fiscal_year))
						// 	}							
						// 	resolve(true)
						// })

						setCompany(selectedCompany)
						window.location.href = pageReturn;
					})
				}}
			>
				Acessar
			</Button>
		);
		// return (
		// 	<Button variant="primary" className="font-12" type="button" id={btn_id} onClick={() => {
		// 		ResalesRequestService.getResale(company.id).then(({data})=>{
		// 			setCompany(data.data)
		// 			window.location.href = pageReturn;
		// 		})
		// 	}}>
		// 		Acessar
		// 	</Button>
		// );
	}

	const updateFiscalYear = async (company) => {
    const setFiscalYear = async (fy) => {
      localStorage.setItem('Elite:fiscalYear', JSON.stringify(fy));
    }

    if (company.adhesion.length > 0) {
      const adhesion = AdminProfiles.includes(profile.id) 
        ? company.adhesion[0] 
        : company.adhesion.find(year => year.fiscal_year.block !== 1)

        if (adhesion?.fiscal_year) {
          setFiscalYear(adhesion.fiscal_year)
        }
    } else {
      setFiscalYear(company.current_fiscal_year)
    }
  }

	renderData();
	const minWidth = 370;
	const isMobile = window.innerWidth < minWidth;
	const getTamanho = (tamanho) => {
		return window.innerWidth <= tamanho;
	}

	return (
		<>
			<Row>
				<Col xs={12} md={4}>
					<Form.Group>
						<Form.Label>Registros por página:</Form.Label>
						<Form.Control
							as="select"
							value={filters.per_page}
							onChange={e =>
								handleFilterChange({ per_page: e.target.value, page: 1 })
							}
						>
							<option value={10}>10</option>
							<option value={25}>25</option>
							<option value={50}>50</option>
							<option value={100}>100</option>
						</Form.Control>
					</Form.Group>
				</Col>
				{isAdmin || isElite || [47, 49].includes(profile.id) ? (
					<Col xs={12} md={2}>
						<Form.Group>
							<Form.Label>Elite:</Form.Label>
							<Form.Control
								as="select"
								value={filters.premium}
								onChange={e =>
									handleFilterChange({ premium: e.target.value, page: 1 })
								}
							>
								<option value="">Todos</option>
								<option value="1">Outros</option>
								{/* <option value="1">Elite</option>
								<option value="2">Elite Gerencial</option>
								<option value="3">Scancash</option> */}
								<option value="5">ScanSource Select</option>
							</Form.Control>
						</Form.Group>
					</Col>
				) : (<></>)}
				{isMasterAgent || isAdmin ? (
					<Col xs={12} md={2}>
						<Form.Group>
							<Form.Label>Master Agent:</Form.Label>
							<Form.Control
								as="select"
								disabled={isMasterAgent && ![47, 49].includes(profile.id)}
								value={filters.masteragent}
								onChange={e =>
									handleFilterChange({ masteragent: e.target.value, page: 1 })
								}
							>
								<option value="">Todos</option>
								<option value="1" selected={isMasterAgent}>Sim</option>
								<option value="0">Não</option>
							</Form.Control>
						</Form.Group>
					</Col>
				) : (<></>)}
				<Col xs={12} md={4}>
					<Form.Group>
						<Form.Label>Pesquisa:</Form.Label>
						<DebounceInput
							element={Form.Control}
							debounceTimeout={500}
							onChange={(e) =>
								handleFilterChange({
									search: e.target.value,
									page: 1,
								})
							}
						/>
						{/* <Form.Control
							as="input"
							onChange={e => handleFilterChange({ search: '%' + e.target.value + '%', page: 1 })}
						>
						</Form.Control> */}
					</Form.Group>
				</Col>
			</Row>
			{isLoading ? (<Loading page />) : (
				<Row className="mt-4">
					<Col className="p-0">
						<BootstrapTable
							wrapperClasses={getTamanho(940) ? 'table-responsive' : ''}
							id="table"
							className="font-10"
							keyField="id"
							data={Data}
							columns={columns}
							striped
							bordered
							hover
							condensed
						/>
						<Row>
							<Col md={6} xs={12}>
								<Trans i18nKey="label:interpolateShowingRecords">
									Showing {{ from: pagination.from || '0' }} to{' '}
									{{ to: pagination.to || '0' }} from {{ total: pagination.total }}{' '}
									records
								</Trans>
							</Col>
							<Col className="d-flex justify-content-end" md={6} xs={12}>
								<Pagination
									activePage={pagination.current_page}
									itemsCountPerPage={pagination.per_page}
									totalItemsCount={pagination.total}
									pageRangeDisplayed={isMobile ? 3 : 5}
									onChange={handlePageChange}
									itemClass="page-item"
									linkClass="page-link"
									prevPageText="‹"
									nextPageText="›"
								/>
							</Col>
						</Row>
					</Col>
				</Row>
			)}
		</>
	);
};

export default CompaniesList;